const imageList = {
  imageOne: ['defnder-90-td5-country-station-wagon-interior', 'restored defender 90 interior'],
  imageTwo: ['land-rover-110-restored', 'restored defender 110'],
  imageThree: ['land-rover-110-v8-1994-restored', 'restored 1994 defender 110v8'],

};

export default imageList;
